export default "__VITE_ASSET__Dd3TYi7y__"